export default {
  haveAccess: false,
  access_token: "",
  accessTokenExpDate: null,
  roles: [],
  user_info: {}
};
